'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENABLED = exports.ENABLED = ['enabled'];

var SCROLL_PERCENTAGE = exports.SCROLL_PERCENTAGE = ['scrollPercentage'];